import { ldb } from '@codesuma/baseline'

// The ids of the occasion copies older versions wrote into the phone's
// calendars. Emrouz no longer writes them, and the ones already there were left
// as the user's own. The reader still keeps them out of its list, so an occasion
// does not show twice on its day — see services/phone-calendar.ts.
export function occasionCopyIds(): string[] {
    const saved = ldb.get('occasion-calendar-copies')
    return Array.isArray(saved) ? saved.map(c => c?.id).filter((id): id is string => typeof id === 'string') : []
}
